import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, Col, Container, Row } from "reactstrap"
import {
  deleteMediaGalleryItem,
  deleteMediaReport,
  getFlaggedMedia,
  getSelectedEvent,
  resetFlaggedMedia,
  resetSelectedEvent,
} from "store/actions"
import { URL_PATHS } from "constants/index"
import ModalComponent from "components/Modals"

const FlaggedContent = ({
  match,
  history,
  getFlaggedMedia,
  resetFlaggedMedia,
  flaggedMedia,
  resetSelectedEvent,
  getEvent,
  selectedEvent,
  deleteMediaReport,
  deleteMediaGalleryItem,
}) => {
  const [viewModalIsOpen, setViewModalIsOpen] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  useEffect(() => {
    if (vendor_id && event_id) {
      getFlaggedMedia({ id: event_id })
      getEvent(event_id)
    }
    return () => {
      resetFlaggedMedia()
      resetSelectedEvent()
    }
  }, [])

  const { vendor_id, event_id } = match?.params

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Reported content" />
          <BreadcrumbTitle
            title={`Reported content ${
              selectedEvent ? " - " + selectedEvent?.name : ""
            } `}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experiences",
                link: "/experiences",
              },
              {
                title: "Edit Experience",
                link: generatePath(URL_PATHS.EDIT_EXPERIENCE, {
                  vendor_id: vendor_id,
                  id: event_id,
                }),
              },
              { title: "Reported content" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {flaggedMedia?.length === 0 ? (
            <Row className="justify-content-center">
              <Col xs="auto">
                <h5>There is no data to display</h5>
              </Col>
            </Row>
          ) : (
            flaggedMedia?.map((item, index) => (
              <Card key={index} className="p-3">
                <Row>
                  <Col sm={2}>
                    {(item?.gallery?.file?.type === "image" ||
                      item?.gallery?.file?.type === "photo") && (
                      <img
                        className="img-thumbnail"
                        width="200"
                        src={item?.gallery?.file?.url}
                      />
                    )}
                    {item?.gallery?.file?.type === "video" && (
                      <video width="200" style={{ maxWidth: "100%" }}>
                        <source src={item?.gallery?.file?.url} />
                      </video>
                    )}
                  </Col>
                  <Col className="align-self-center">
                    <Row className="mb-2">
                      <Col className="fs-5">
                        Reported by {item?.reporter?.display_name}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="auto" className="my-1">
                        <SaveButton
                          type="button"
                          content="View file"
                          onClick={() => {
                            setViewModalIsOpen(true)
                            setSelectedFile(item?.gallery)
                          }}
                        />
                      </Col>
                      <Col xs="auto" className="my-1">
                        <SaveButton
                          type="button"
                          content="Delete report"
                          color="danger"
                          onClick={() => deleteMediaReport({ id: item?.id })}
                        />
                      </Col>
                      <Col xs="auto" className="my-1">
                        <SaveButton
                          type="button"
                          content="Delete file"
                          color="danger"
                          onClick={() =>
                            deleteMediaGalleryItem({
                              data: {
                                event_id: event_id,
                                ids: [item?.gallery?.id],
                              },
                            })
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            ))
          )}
        </Container>
      </div>
      <ModalComponent
        open={viewModalIsOpen}
        onClose={() => setViewModalIsOpen(false)}
      >
        <div className="d-flex justify-content-center">
          {(selectedFile?.file?.type === "image" ||
            selectedFile?.file?.type === "photo") && (
            <img
              className="img-thumbnail"
              style={{ maxWidth: "100%" }}
              src={selectedFile?.file?.url}
            />
          )}
          {selectedFile?.file?.type === "video" && (
            <video style={{ maxWidth: "100%" }} controls>
              <source src={selectedFile?.file?.url} />
            </video>
          )}
        </div>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  flaggedMedia: state.MediaGallery.flaggedMedia,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  getFlaggedMedia: values => dispatch(getFlaggedMedia(values)),
  resetFlaggedMedia: () => dispatch(resetFlaggedMedia()),
  getEvent: values => dispatch(getSelectedEvent(values)),
  resetSelectedEvent: () => dispatch(resetSelectedEvent()),
  deleteMediaReport: values => dispatch(deleteMediaReport(values)),
  deleteMediaGalleryItem: values => dispatch(deleteMediaGalleryItem(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FlaggedContent))
